import { SeatingSequence } from '../interfaces';
import { MAX_SEAT_LABEL_LENGTH } from '../constants';
const CHARS_IN_ALPHABET = 26;
const labelRe = /^([A-Za-z]+)$/;
const isValidAlphabeticLabel = (label) => label.match(labelRe) && label.length <= MAX_SEAT_LABEL_LENGTH;
export const isValidLowercaseLabel = (label) => isValidAlphabeticLabel(label) && isLowerCase(label);
export const isValidUppercaseLabel = (label) => isValidAlphabeticLabel(label) && isUpperCase(label);
export const isNumericLabel = (label) => !isNaN(Number(label));
export const isValidLabel = (label) => isNumericLabel(label) || isValidLowercaseLabel(label) || isValidUppercaseLabel(label);
export const isLowerCase = (label) => label.toLowerCase() === label;
export const isUpperCase = (label) => label.toUpperCase() === label;
export const NumericLabel = () => ({
    labelToNumber: (label) => Number(label),
    numberToLabel: (num) => num.toString(),
});
export const AlphabeticLabel = (lowerCase) => {
    const charCodeA = lowerCase ? 'a'.charCodeAt(0) : 'A'.charCodeAt(0);
    const labelToNumber = (label) => label.split('').reduce((sum, char, charIndex) => {
        const position = label.length - charIndex - 1;
        return sum + (char.charCodeAt(0) - charCodeA + 1) * CHARS_IN_ALPHABET ** position;
    }, 0);
    const numberToLabel = (num) => {
        const charPosition = (num - 1) % CHARS_IN_ALPHABET;
        const char = String.fromCharCode(charCodeA + charPosition);
        const next = Math.floor((num - 1) / CHARS_IN_ALPHABET);
        if (next > 0) {
            return numberToLabel(next) + char;
        }
        return char;
    };
    return {
        labelToNumber,
        numberToLabel,
    };
};
export const nextLabel = (sequence, label) => {
    const { labelToNumber, numberToLabel } = sequenceToGenerator(sequence, label);
    return numberToLabel(labelToNumber(label) + 1);
};
export const sequenceToGenerator = (sequence, exampleLabel) => isNumericSequence(sequence) ? NumericLabel() : AlphabeticLabel(isLowerCase(exampleLabel));
export const isNumericSequence = (sequence) => {
    if (sequence === undefined) {
        return true;
    }
    return sequence === SeatingSequence.NUMERIC || sequence === SeatingSequence.NUMERIC_EVEN_OR_ODD;
};
export const createLabelGenerator = ({ sequence, startAt, reverseDirection, capacity }) => {
    const getLabelByIndex = (index, indexOffset = 0) => {
        const { labelToNumber, numberToLabel } = isNumericSequence(sequence)
            ? NumericLabel()
            : AlphabeticLabel(isLowerCase(startAt));
        const step = sequence === SeatingSequence.NUMERIC_EVEN_OR_ODD ? 2 : 1;
        const indexWithOffset = index + indexOffset;
        const sequenceStartNumber = labelToNumber(startAt);
        const sequenceEndNumber = sequenceStartNumber + step * capacity;
        const sequenceStartRespectingReverse = reverseDirection ? sequenceEndNumber - step : sequenceStartNumber;
        const numberDiff = step * (reverseDirection ? -1 : 1) * indexWithOffset;
        const calculatedNumber = sequenceStartRespectingReverse + numberDiff;
        return numberToLabel(calculatedNumber);
    };
    const getLabels = (indexOffset = 0) => new Array(capacity).fill(null).map((_, index) => getLabelByIndex(index, indexOffset));
    return { getLabelByIndex, getLabels };
};
//# sourceMappingURL=label-generator.js.map